export default __webpack_public_path__ + "static/media/search.2da2bea4.svg";